import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

export type KategoriReaksi = "demam" | "alergi" | "hemolisis" | "lainnya";

export interface ReaksiTransfusiFilter {
  tgl_start: string;
  tgl_end: string;
  unit_id?: string | null;
  kategori?: KategoriReaksi | null;
  term?: string | null;
}

export interface ReaksiTransfusiRow {
  id: number;
  register_id: string;
  tanggal_kejadian: string | null;
  tanggal_kejadian_label: string;
  pasien_rm: string;
  pasien_nama: string;
  unit_id: string | null;
  unit_nama: string;
  golongan_darah_pasien: string;
  nomor_kantong: string | null;
  komponen: string | null;
  golongan_darah_donor: string;
  hasil_crossmatch: string | null;
  kategori: KategoriReaksi[];
  lainnya: string[];
  reaksi_teks: string;
  derajat_terberat: string;
  transfusi_dihentikan: boolean;
  petugas_transfusi: string | null;
  tanggal_crosstest: string | null;
  tanggal_darah_keluar: string | null;
  petugas_bdrs: string | null;
  petugas_pengambil_darah: string | null;
  dokter_dikonsulkan_nama: string | null;
  tindakan_setelah_konsul: string | null;
  laporan_lengkap: boolean;
}

export interface ReaksiTransfusiResponse {
  rows: ReaksiTransfusiRow[];
  summary: {
    total: number;
    lengkap: number;
    per_kategori: Record<KategoriReaksi, number>;
  };
  kategori: Record<KategoriReaksi, string>;
}

function params(f: ReaksiTransfusiFilter) {
  return {
    tgl_start: f.tgl_start,
    tgl_end: f.tgl_end,
    unit_id: f.unit_id || undefined,
    kategori: f.kategori || undefined,
    term: f.term || undefined
  };
}

async function list(f: ReaksiTransfusiFilter): Promise<ReaksiTransfusiResponse> {
  const res = await http
    .getDataParam(`/laporan/bank-darah/reaksi-transfusi`, { params: params(f) })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data.data;
}

async function downloadExcel(f: ReaksiTransfusiFilter): Promise<void> {
  const res = await http
    .getDataParam(`/laporan/bank-darah/reaksi-transfusi/excel`, {
      params: params(f),
      responseType: "blob"
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = `laporan-reaksi-transfusi_${f.tgl_start}_${f.tgl_end}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default { list, downloadExcel };
